export default __webpack_public_path__ + "static/media/health.0835cedb.png";